var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "core-js/modules/es6.regexp.split", "core-js/modules/es7.array.includes", "core-js/modules/es6.string.includes", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "querystring"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("core-js/modules/es6.regexp.split"), require("core-js/modules/es7.array.includes"), require("core-js/modules/es6.string.includes"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("querystring"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.es6Regexp, global.es7Array, global.es6String, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.querystring);
    global.VideoEmbed = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _es6Regexp2, _es7Array, _es6String, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _querystring) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var VideoEmbed = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(VideoEmbed, _PureComponent);

    var _super = _createSuper(VideoEmbed);

    function VideoEmbed(props) {
      var _this;

      (0, _classCallCheck2.default)(this, VideoEmbed);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onWindowEvent", function (event) {
        var data = event.data;

        if (['nextItem', 'play', 'pause'].includes(data.event)) {
          _this.props.onPlayerEvent(event);
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initPlayer", function (ref) {
        _this.player = ref;
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "playerAttribute", function () {
        var playerUrl = _this.props.playerUrl;
        var isPlaylist = playerUrl.indexOf('json_playlist_url') !== -1;
        return (0, _defineProperty2.default)({}, isPlaylist ? 'data-playlist_url' : 'data-url', (0, _querystring.parse)(playerUrl.split('?')[1])[isPlaylist ? 'json_playlist_url' : 'json_url']);
      });
      _this.player = null;
      return _this;
    }

    (0, _createClass2.default)(VideoEmbed, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.player) {
          this.player.addEventListener('arte_vp_data_loaded', this.props.onVideoLoaded);
          global.window.addEventListener('message', this.onWindowEvent, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.player) {
          this.player.removeEventListener('arte_vp_data_loaded', this.props.onVideoLoaded);
          global.window.removeEventListener('message', this.onWindowEvent, false);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            iframe = _this$props.iframe,
            playerUrl = _this$props.playerUrl;
        var sharedProps = {
          ref: this.initPlayer,
          className: 'video-embed'
        };
        return iframe ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          dangerouslySetInnerHTML: {
            __html: iframe
          } // eslint-disable-line

        }, sharedProps)) : /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sharedProps, this.playerAttribute()), /*#__PURE__*/_react.default.createElement("iframe", {
          allowFullScreen: true,
          frameBorder: "0",
          height: "100%",
          scrolling: "no",
          src: playerUrl,
          title: "Video Player",
          width: "100%"
        }));
      }
    }]);
    return VideoEmbed;
  }(_react.PureComponent);

  VideoEmbed.propTypes = {
    iframe: _propTypes.default.string,
    playerUrl: _propTypes.default.string,
    onVideoLoaded: _propTypes.default.func,
    onPlayerEvent: _propTypes.default.func
  };
  VideoEmbed.defaultProps = {
    iframe: '',
    playerUrl: '',
    onVideoLoaded: function onVideoLoaded() {},
    onPlayerEvent: function onPlayerEvent() {}
  };
  var _default = VideoEmbed;
  _exports.default = _default;
});